<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="info" fixed="top" m>
      <b-navbar-brand href="/">CST Home</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#/">
            {{firstCap(this.user.role)}}
            {{ this.user.meta_info ? this.user.meta_info.code : null}}
            id: {{this.user.user_id}}

          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown text="Forms" right>
            <b-dropdown-item v-if="user.role=='district' || user.role=='operations'">
              <router-link to="/RequestForm">Request Form</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.role=='vendor' || user.role=='operations'">
                <router-link to="/DailyNoShowForm">Daily No-show Form</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.role=='district' || user.role=='operations'">
              <router-link to="/CalendarForm">Calendar Form</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.role=='district' || user.role=='operations'">
              <router-link to="/StudentList">Student List</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{userName}}</em>
            </template>
            <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
            <b-dropdown-item href="/login/?action=logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { getUser } from '../services/api.js';
export default {
  props: {
  },
  data() {
    return {
      user: {},
      userName: "",
    }
  },
  methods: {
    firstCap(s) {
      return s?.charAt(0).toUpperCase() + s?.slice(1);
    },
    async updateUser() {
      let userResponse = await getUser()
      if (userResponse.status !== 200) {
        alert("Network Problem")
        throw new Error(userResponse.statusText);
      }
      this.user = userResponse.data
      this.userName = this.user.user_first_name + ' ' + this.user.user_last_name
    },
  },
  mounted() {
    this.updateUser()
  },
}
</script>
